export default function formAlerts() {
    const alertDismissButtons = document.querySelectorAll('[data-dismiss="alert"]');
    alertDismissButtons.forEach((button) => {
        button.addEventListener('click', () => {
            button.parentElement.remove();
        });
    });
}
